module.exports = {
          srcSet: __webpack_public_path__ + "2639913bd1c0abba186cc37e4f2a4398-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "2639913bd1c0abba186cc37e4f2a4398-24.png",width: 24,height: 24}],
          src: __webpack_public_path__ + "2639913bd1c0abba186cc37e4f2a4398-24.png",
          toString:function(){return __webpack_public_path__ + "2639913bd1c0abba186cc37e4f2a4398-24.png"},
          
          width: 24,
          height: 24
        }